const getRandomWidth = () => {
  const randomNum = Math.floor(Math.random() * 5);

  return `w-${randomNum + 7}/12`;
};

export { getRandomWidth };
